module.exports = __webpack_public_path__ + "media/bootstrap-icons/compass-156b2c2c.svg";